// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-mail-top-container{display:flex;flex-direction:column}@media screen and (min-width: 576px){.main-mail-top-container{flex-direction:row}}.main-mail-headers-container{flex-grow:1;margin-bottom:.5em}@media screen and (min-width: 576px){.main-mail-headers-container{margin-bottom:0}}", ""]);
// Exports
module.exports = exports;
